function InputHandler(stateSetter){
    return function(e){
        stateSetter(e.target.value);
    }
}

export default InputHandler